export default __webpack_public_path__ + "static/media/download-blue.f79e1fb5.svg";